import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import css from './NextActionBand.module.scss';

export interface NextAction {
  /** State key, used for analytics + styling. */
  key: string;
  copy: string;
  buttonLabel: string;
  onClick: () => void;
  /** Loud (filled green) vs quiet (calm, caught-up) treatment. */
  loud: boolean;
}

/** One state-driven primary action — the single loud call on the dashboard. */
const NextActionBand: React.FC<{ action: NextAction }> = ({ action }) => (
  <section className={`${css.band} ${action.loud ? css.loud : css.quiet}`} aria-label="What to do next">
    <p className={css.copy}>{action.copy}</p>
    <button type="button" className={css.button} onClick={action.onClick}>
      {action.buttonLabel}
      <ArrowRightOutlined className={css.arrow} />
    </button>
  </section>
);

export default NextActionBand;
